import { render, staticRenderFns } from "./MultipleCombobox.vue?vue&type=template&id=1386c8c0&scoped=true&"
import script from "./MultipleCombobox.vue?vue&type=script&lang=js&"
export * from "./MultipleCombobox.vue?vue&type=script&lang=js&"
import style0 from "./MultipleCombobox.vue?vue&type=style&index=0&id=1386c8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386c8c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
